var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-pause',
                        view: publicPath + 'sprite.svg#view-icon-pause',
                        viewBox: '0 0 357 357',
                        title: 'icons/fonctions/pause',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };